import { AVALIACOES_NAMESPACE } from './constants';
import { buildResult, generateId, nowISO } from './helpers';
import { createIndexedDbBackend } from './backends/indexedDbBackend';
import { createLocalStorageBackend } from './backends/localStorageBackend';

let forceLocalStorage = false;
const INFRA_ERROR_CODES = new Set([
  'IDB_UNAVAILABLE',
  'IDB_OPEN_FAILED',
  'IDB_TX_FAILED',
  'IDB_UPGRADE_FAILED'
]);

export const setForceLocalStorage = value => {
  forceLocalStorage = Boolean(value);
};

export const createMockStore = ({ namespace = AVALIACOES_NAMESPACE } = {}) => {
  const indexedDb = createIndexedDbBackend();
  const localStorageBackend = createLocalStorageBackend();

  const resolveBackend = async preferredCall => {
    if (forceLocalStorage) {
      return preferredCall(localStorageBackend);
    }

    const result = await preferredCall(indexedDb);
    const errorCode = result && result.error && result.error.code;

    if (result && (result.ok || !INFRA_ERROR_CODES.has(errorCode))) {
      return result;
    }

    return preferredCall(localStorageBackend);
  };

  return {
    setForceLocalStorage,

    async list(collection) {
      return resolveBackend(backend => backend.list(namespace, collection));
    },

    async getById(collection, id) {
      return resolveBackend(backend => backend.getById(namespace, collection, id));
    },

    async create(collection, payload) {
      const nextPayload = {
        ...payload,
        id: payload && payload.id ? payload.id : generateId(),
        created_at: payload && payload.created_at ? payload.created_at : nowISO(),
        updated_at: nowISO()
      };

      return resolveBackend(backend => backend.create(namespace, collection, nextPayload));
    },

    async update(collection, id, payload) {
      const nextPayload = {
        ...payload,
        id,
        updated_at: nowISO()
      };

      return resolveBackend(backend => backend.update(namespace, collection, id, nextPayload));
    },

    async remove(collection, id) {
      return resolveBackend(backend => backend.remove(namespace, collection, id));
    },

    async clear(collection) {
      return resolveBackend(backend => backend.clear(namespace, collection));
    },

    async healthcheck() {
      try {
        const result = await resolveBackend(backend => backend.list(namespace, '__healthcheck__'));
        return buildResult({ ok: Boolean(result && result.ok), data: result });
      } catch (error) {
        return buildResult({ ok: false, error });
      }
    }
  };
};
